import { render, staticRenderFns } from "./BaseOverview.vue?vue&type=template&id=5fc0c27a&scoped=true&"
import script from "./BaseOverview.vue?vue&type=script&lang=ts&"
export * from "./BaseOverview.vue?vue&type=script&lang=ts&"
import style0 from "./BaseOverview.vue?vue&type=style&index=0&id=5fc0c27a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0c27a",
  null
  
)

export default component.exports